<div class="categoria-principale">
  <mat-card>
            <mat-card-subtitle>{{titolo}}</mat-card-subtitle>
            <mat-nav-list>
                <a mat-list-item (click)="onSelect(cat)" *ngFor="let cat of categoriePrincipali"> {{ cat.nome }} </a>
            </mat-nav-list>
        </mat-card>
    </div> 


// WEBPACK FOOTER //
// ./src/app/tws-categoria/tws-categoria-inline.component.html